import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('notificationStore', Object.keys(state)),
	...mapGetters('notificationStore', Object.keys(getters))
};
export const serviceMethods = {
	...mapActions('notificationStore', Object.keys(actions)),
	...mapMutations('notificationStore', Object.keys(mutations))
};
